<template>
	<div class="paginator">
		<p v-if="!meta.total">No matches</p>
		<p
			v-else-if="meta.total <= meta.per_page"
			v-html="stringer('Showing ?').nGetText('only match', 'all # matches', meta.total).value"/>
		<p
			v-else
			v-html="stringer('Showing # to # of # matches').replaceArray('#', [meta.from, meta.to, meta.total]).value"/>
		<ul v-if="meta && meta.total > meta.per_page">
			<li>
				<button
					:disabled="!links.prev" class="button button--secondary--small"
					v-on:click="goTo(meta.current_page - 1)">Prev
				</button>
			</li>
			<li>
				<select
					v-model="meta.current_page" class="button button--secondary--small"
					@change="goTo($event.target.value)">
					<option v-for="n in meta.last_page" :value="n" v-html="n"/>
				</select>
			</li>
			<li>
				<button
					:disabled="!links.next" class="button button--secondary--small"
					v-on:click="goTo(meta.current_page + 1)">Next
				</button>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	props: {
		meta: null,
		links: null,
	},

	methods: {
		goTo(page) {
			if (page < 1) {
				page = 1;
			}

			if (page > this.meta.last_page) {
				page = this.meta.last_page;
			}

			this.$parent.goToPage(page);
		},
	},
};
</script>
